import { config } from "config";

// Legacy-compatible permission check.
//
// Permissions were split: read -> view + read, write -> add + edit. During the
// window between deploying this frontend and running the role migration script,
// a user logged in against an un-migrated role still carries the OLD permission
// strings (`x:read`, `x:write`) in `auth.user.role_id.permissions`. Treat those
// as satisfying the new granular checks so the UI does not break meanwhile:
//   x:view  is satisfied by  x:read   (legacy)
//   x:add   is satisfied by  x:write  (legacy)
//   x:edit  is satisfied by  x:write  (legacy)
// This mirrors the backend derive fallback (utils/derive_role_access.utils.js)
// and never over-grants: a user with only `x:read` (no `x:write`) still fails an
// `x:add`/`x:edit` check. Once migrated + re-logged-in, the exact strings match.
export const hasPermission = (list: any, required: string): boolean => {
  if (!Array.isArray(list) || !required) return false;
  if (list.includes(required)) return true;
  const [module, action] = required.split(":");
  if (!module || !action) return false;
  if (action === "view") return list.includes(`${module}:read`);
  if (action === "add" || action === "edit") return list.includes(`${module}:write`);
  return false;
};

/** May cancel bookings directly, review pending cancellation requests, and refund paid bookings. */
export const isBookingModificationPrivileged = (email?: string): boolean =>
  config.PRIVILEGES.bookingModification.includes(
    (email || "").trim().toLowerCase()
  );

const PrivilegeService = {
  checkPrivilege: (access: String, privilege: any) => {
    return hasPermission(privilege, access as string);
  },
};

export default PrivilegeService;
